import { UntypedFormGroup } from '@angular/forms';
import omit from 'lodash-es/omit';

import { PERSON_FORM_INPUTS } from '@booking/constants/forms.constants';
import { BillingInfo } from '@billing/entities/billing.payload';

export function naturalPersonBillingMapper(form: UntypedFormGroup): BillingInfo {
  const billingInfo = {
    ...form.value,
    [PERSON_FORM_INPUTS.DOCUMENT_ID]: form.controls[PERSON_FORM_INPUTS.DOCUMENT_ID].value,
    [PERSON_FORM_INPUTS.DOCUMENT_NUMBER]: form.controls[PERSON_FORM_INPUTS.DOCUMENT_NUMBER].value,
    [PERSON_FORM_INPUTS.ADDRESS]: { ...form.controls[PERSON_FORM_INPUTS.ADDRESS].value }
  };
  return omit(billingInfo, [PERSON_FORM_INPUTS.FISCAL_RESPONSIBILITY]);
}
